<template>
  <div>
  <section>
        <div class="container">
            <ol class="breadcrumb hidden-xs">
                <li><a href="/">首頁</a></li>
                <li class="active">FAQ</li>
            </ol>
            <div class="row">
                <div class="col-smmd-offset-2 col-sm-8">
                    <h4 class="text-center title">FAQ</h4>
                    <div class="panel-group" id="accordion faq" role="tablist" aria-multiselectable="true">
                        <div class="panel panel-default faq_box">
                            <div class="panel-heading" role="tab" id="headingOne">
                                <h4 class="panel-title title">
                                    <a role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                        會員回饋金何時發放?
                                    </a>
                                </h4>
                            </div>
                            <div id="collapseOne" class="panel-collapse collapse in" role="tabpanel" aria-labelledby="headingOne">
                                <div class="panel-body">
                                    會員於上個月進行消費所產生的點數，以及包含推薦的會員消費，系統會統一進行計算後於隔月15號一併發放回饋金給會員，並且保存於會員中心的紀錄中。
                                </div>
                            </div>
                        </div>
                        <div class="panel panel-default faq_box">
                            <div class="panel-heading" role="tab" id="headingTwo">
                            <h4 class="panel-title title">
                                <a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                會員如何進行消費與分享?
                                </a>
                            </h4>
                            </div>
                            <div id="collapseTwo" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingTwo">
                                <div class="panel-body">
                                    您只要註冊帳號後系統將會給你一組會員編號，您可以透過分享網址船給您的朋友，讓朋友進行註冊後就算是完成推薦的動作了，爾後當您的朋友購買任何商品都會直接回饋給您。
                                </div>
                            </div>
                        </div>
                        <div class="panel panel-default faq_box">
                            <div class="panel-heading" role="tab" id="headingThree">
                                <h4 class="panel-title title">
                                    <a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                    如果我有認識的好的商品或店家，可以進行推薦嗎?
                                    </a>
                                </h4>
                            </div>
                            <div id="collapseThree" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingThree">
                                <div class="panel-body">
                                    一定可以的!我們的平台需要優質的商品來提供給會員，因此歡迎您提供我們商家的連絡資訊與商品項目，來讓我們進行接洽服務更多會員。
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Faq',
  data () {
    return {
      com_name: ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// Faq.vue?e67db50e